module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/True-Detective-S3.28ade56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/True-Detective-S3.jpg
// module id = iLwi
// module chunks = 0